import React, { useMemo } from "react";
import styles from "./LogoFooter.module.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { CONFIG } from "@/config";
import { useAtomValue } from "jotai";
import { FooterVisible } from "@/atoms";
import classNames from "classnames";
export function LogoFooter(_a) {
    var _b;
    var locale = _a.locale;
    var intl = useIntl();
    // eslint-disable-next-line formatjs/enforce-id
    var ratingId = intl.formatMessage({ id: "age_rating", defaultMessage: "" });
    var rating = useMemo(function () {
        if (ratingId in CONFIG.ratings) {
            return CONFIG.ratings[ratingId];
        }
        else {
            return null;
        }
    }, [ratingId]);
    var footerVisible = useAtomValue(FooterVisible);
    var privacyLink = "https://www.ubisoft.com/legal/documents/privacypolicy/".concat(locale);
    return (React.createElement("div", { className: classNames(styles.logoFooter, (_b = {},
            _b[styles.absolute] = !footerVisible,
            _b)) },
        rating && (React.createElement("div", { className: styles.rating },
            React.createElement("img", { src: rating.file, className: styles.ageRating, alt: rating.alt }),
            !footerVisible && (React.createElement("div", { className: styles.ageLegalCookie },
                React.createElement("a", { href: privacyLink, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(FormattedMessage, { defaultMessage: "PRIVACY", id: "B8jklt" })),
                " | ",
                React.createElement("a", { rel: "noopener noreferrer", onClick: function (e) {
                        var _a, _b;
                        e.preventDefault(); // stops the link from opening
                        (_b = (_a = window.adobeAnalytics) === null || _a === void 0 ? void 0 : _a.displayPrivacySettings) === null || _b === void 0 ? void 0 : _b.call(_a);
                    } },
                    React.createElement(FormattedMessage, { defaultMessage: "SET COOKIE", id: "B8jklc" })))))),
        footerVisible && (React.createElement("div", { className: styles.legal },
            React.createElement(FormattedMessage, { defaultMessage: "Music from Skull and Bones (Original Game Soundtrack). Music composed by Tom Holkenborg. And Music from Skull and Bones : Songs of the Sea (From the Skull and Bones OST). Music by The Busking Barnacles. \u2117 & \u00A9 2022 Ubisoft Music Inc. / Ubisoft Musique Inc. \u00A9 2022 Ubisoft Entertainment. All Rights Reserved. Skull and Bones, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.", id: "B8jklr" }),
            React.createElement("a", { href: privacyLink, target: "_blank", rel: "noopener noreferrer" },
                React.createElement(FormattedMessage, { defaultMessage: "PRIVACY", id: "B8jklt" })),
            " | ",
            React.createElement("a", { rel: "noopener noreferrer", onClick: function (e) {
                    var _a, _b;
                    e.preventDefault(); // stops the link from opening
                    (_b = (_a = window.adobeAnalytics) === null || _a === void 0 ? void 0 : _a.displayPrivacySettings) === null || _b === void 0 ? void 0 : _b.call(_a);
                } },
                React.createElement(FormattedMessage, { defaultMessage: "SET COOKIE", id: "B8jklc" })))),
        React.createElement("div", { className: styles.ubiLogo })));
}
